import { render, staticRenderFns } from "./skuToTon.vue?vue&type=template&id=3a2681a2&scoped=true&"
import script from "./skuToTon.vue?vue&type=script&lang=js&"
export * from "./skuToTon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2681a2",
  null
  
)

export default component.exports